import { render, staticRenderFns } from "./openAcctCrs.vue?vue&type=template&id=64d76b46&scoped=true"
import script from "./openAcctCrs.vue?vue&type=script&lang=js"
export * from "./openAcctCrs.vue?vue&type=script&lang=js"
import style0 from "./openAcctCrs.vue?vue&type=style&index=0&id=64d76b46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d76b46",
  null
  
)

export default component.exports